module.exports = __webpack_public_path__ + "static/media/adesivo_taubescar.38794645.png";